import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const proposalApi = createAsyncThunk("proposal", async ({ startDate = null, endDate = null }) => {
  const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
  const response = await axiosInstance.get("/proposal",{ params });
  return response.data;
});

const proposalSlice = createSlice({
  name: "proposal",
  initialState: {
    proposal: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(proposalApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(proposalApi.fulfilled, (state, action) => {
        state.proposal = action.payload;
        state.loading = false;
      })
      .addCase(proposalApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default proposalSlice.reducer;
